import {Address, Contact} from '@rbaip/address-form';

export class SellerLocation {
  id: number;
  cntctId: number;
  pickupHours: string;
  pickupLimits: string;
  loadingDock: string;
  willSellerLoad: string;
  forklift: string;
  ramp: string;
  inspContact: Contact;
  altInspContact: Contact;
  transportContact: Contact;
  addressDto: Address;
  oneLineFullAddress: string;
  locationDesc: string;
  companyName: string;
  siteId: number;
  contactCount: number;
  newLocation: boolean;
  sellerId: number;
  streetAdd1: string;
  streetAdd2: string;
  city: string;
  prov: string;
  postalCode: string;
  country: string;
   pickupSupportYn: string='N';
   activeYn: string = 'Y';
  createdDate: Date = new Date();
  defaultYn: string;
  openTime: string;
  closeTime: string;
  lunchStartTime: string;
  lunchEndTime: string;
  hasSoldAsset: boolean;
  auctionEventId: number;
  storageInspInstructions: string;
  sendReleaseToTransportPoc: boolean;
}
